import { FC } from 'react';

type WlasWidgetIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const WlasWidgetIcon: FC<WlasWidgetIconProps> = ({ width = 20, height = 20, ...rest }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10 10H10.0083"
      stroke="#647DAF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3337 5.00008V3.33341C13.3337 2.89139 13.1581 2.46746 12.8455 2.1549C12.5329 1.84234 12.109 1.66675 11.667 1.66675H8.33366C7.89163 1.66675 7.46771 1.84234 7.15515 2.1549C6.84259 2.46746 6.66699 2.89139 6.66699 3.33341V5.00008"
      stroke="#647DAF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3337 10.8333C15.861 12.4657 12.9633 13.336 10.0003 13.336C7.03737 13.336 4.13967 12.4657 1.66699 10.8333"
      stroke="#647DAF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.667 5H3.33366C2.41318 5 1.66699 5.74619 1.66699 6.66667V15C1.66699 15.9205 2.41318 16.6667 3.33366 16.6667H16.667C17.5875 16.6667 18.3337 15.9205 18.3337 15V6.66667C18.3337 5.74619 17.5875 5 16.667 5Z"
      stroke="#647DAF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
